import { CSLocales, CSSoftwareApplications_Language_Entry } from '@websrc/Typings/ContentStack'

export function getLanguageIndexForLocaleWithLanguages(
  locale: CSLocales,
  languages: CSSoftwareApplications_Language_Entry['entry']['language'][]
) {
  let index = -1

  // First choices, if any of these hits, go for it!
  const langMap: Partial<
    Record<CSLocales, CSSoftwareApplications_Language_Entry['entry']['language'][]>
  > = {
    'da-dk': ['Dansk', 'Nordic'],
    'sv-se': ['Svenska', 'Nordic'],
    'nb-no': ['Norsk', 'Nordic'],
    'de-de': ['Deutsch'],
    'en-us': ['English (United States)', 'Americas'],
    'en-gb': ['English (UK)', 'English (United States)'],
    'en-au': ['English (Australia)', 'English (UK)', 'English (United States)'],
    'tr-tr': ['Türkçe'],
    'es-es': ['Español'],
    'es-mx': ['Español (Mexico)', 'Español'],
    'fi-fi': ['Suomi', 'Nordic'],
    'it-it': ['Italiano'],
    'pl-pl': ['Polski'],
    'fr-fr': ['Français', 'Français (Canada)'],
    'nl-nl': ['Nederlands'],
    'pt-br': ['Português'],
    'ru-ru': ['Русский', 'Asia Pacific & Russia'],
    'ar-ae': ['Arabic'],
    'ja-jp': ['日本語', 'Asia Pacific & Russia'],
    'ko-kr': ['한국어', 'Asia Pacific & Russia'],
    'zh-cn': ['中文', 'Asia Pacific & Russia'],
  }

  // Fallback mechanism: Always take Global, then United States.
  const defaultFallbacks: typeof languages = ['Global', 'English (United States)']

  const iterator = (lang: (typeof languages)[0]) => {
    const lI = languages.indexOf(lang)

    if (lI > -1 && index === -1) {
      index = lI
    }
  }

  langMap[locale]?.forEach(iterator)
  defaultFallbacks.forEach(iterator)

  return Math.max(index, 0)
}
